const TRACKING_KEYS = [
  'utm_campaign',
  'utm_source',
  'utm_medium',
  'utm_term',
  'utm_content',
  'campaign',
];

function filterObject(
  obj: Record<string, string>,
  filterKeys: string[]
): {
  [k: string]: string | (string | null)[] | null;
} {
  return Object.fromEntries(Object.entries(obj).filter(([k]) => filterKeys.includes(k)));
}

export default function getUtmParams(urlParams: Record<string, string>): {
  [k: string]: string | (string | null)[] | null;
} {
  const filteredParams = filterObject(urlParams, TRACKING_KEYS);
  return {
    campaign: filteredParams.utm_campaign || filteredParams.campaign,
    source: filteredParams.utm_source,
    medium: filteredParams.utm_medium,
    term: filteredParams.utm_term,
    content: filteredParams.utm_content,
  };
}
